/* 
  This is the service responsible for checking soft limits and enforcing hard limits
  soft limit: e.g.: send email/push/sms to the user 
  hard limit: e.g.: shut down fermentation process
*/

import { Plugin } from "plugin";

class LimitsService extends Plugin {
  constructor(...args) {
    super(...args);
            
    this.addEventListener("update", this.#update_handler.bind(this));    
  }
  #update_handler(event) {
    var devices = event.detail;
    if (devices.ezortdSensor && devices.ezortdSensor.value > 55)
      this.dispatchEvent( new CustomEvent("stop", {detail: "temperature hard limit violation"}) );
  }      
}

export default LimitsService;